<template>
  <div>
    <figure class="image is-square">
      <div v-if="url" class="image" :style="{backgroundImage: 'url(' + url + ')'}" ></div>
    </figure>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  props: [ 'media', 'imageID', 'imagePath', 'thumbSize' ],
  data () {
    return {
      url: null,
      loading: true,
      error: null
    }
  },
  computed: {
    image () {
      return this.media.find((image) => image['.key'] === this.imageID)
    }
  },
  methods: {
    getImgUrl () {
      let storage = firebase.storage().ref()
      let imageRef = storage.child('thumbs/' + this.image.name + '_' + this.thumbSize + '_thumb.jpg')
      imageRef.getDownloadURL()
        .then(
          (url) => {
            this.loading = false
            this.url = url
          },
          (error) => {
            switch (error.code) {
              case 'storage/object_not_found':
                console.log('File doesn\'t exist')
                break
              case 'storage/unauthorized':
                console.log('User doesn\'t have permission to access the object')
                break
              case 'storage/canceled':
                console.log('User canceled the upload')
                break
              case 'storage/unknown':
                console.log('Unknown error occurred, inspect the server response')
                break
            }
            this.loading = false
            this.error = error
          }
        )
    }
  },
  watch: {
    imageID () {
      this.getImgUrl()
    },
    image () {
      this.getImgUrl()
    }
  }
}
</script>

<style lang="scss" scoped>
  figure {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    min-width: 128px;
    .image {
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      background: red;
      background-position: center center;
      background-size: cover;
    }
  }

  .img-container {
    display: block;
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }

  .delete-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 1;
  }

  .info-tab {
    position: absolute;
    bottom: 0px;
    height: 28px;
    width: 100%;
    padding: 4px;
    background-color: black;
    color: white;
    opacity: 0.71;
    z-index: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .image-div {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    z-index: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/GalleryImage.vue